var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#instagram';
                    var viewUrl = 'svg/global.svg#view-instagram';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };